import React from 'react';
import { _ } from '../../functions/translator';

class CardsGroupsTitle extends React.Component{
    
    render() {   
        let categoryName = this.props.category ? this.props.category.attributes.name : _('Sin') + ' ' + _('Categoría');
        let categoryColor = this.props.category ? this.props.category.attributes.color : 'black';
        let labelStyle = {
            "backgroundColor" : categoryColor
        }
        return (
            <div>
                <h3 className='text-center'>{ categoryName }</h3>
                <div className="color-label" style={ labelStyle }></div>
            </div>
        );
    }
}

export default CardsGroupsTitle
